export function counter(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  return reading
}
